
// mixin 需要注册的子组件方法
export default {
  methods: {
    pre() {
      this.$router.replace({
        path: this.$route.path,
        query: {
          flag: this.$route.query.flag,
          codeId: this.codeId,
          step: this.step - 1
        }
      })
      this.$emit("pre");
    },

    async next() {
      const isValidate = await this.save();
      
      if (!isValidate) return false;
      this.$router.replace({
        path: this.$route.path,
        query: {
          flag: this.$route.query.flag,
          codeId: this.codeId,
          step: this.step + 1
        }
      })
      this.$emit("next", this.codeId);
    },

    async save() {
      const isValidate = this.$refs.form.submitForm();
      if (!isValidate) return false;
      await this.submit(this.$refs.form.form);
      return true;
    },
  }
}